// extracted by mini-css-extract-plugin
export default {"main_header":"MainHeader_main_header__lt0fF"};